import {
  ENABLE_PERFORMANCE_ANALYTICS,
  ENABLE_ENGAGEMENT_ANALYTICS,
  ENABLE_BEHAVIOUR_ANALYTICS,
  ENABLE_MODULE_USAGE_ANALYTICS,
  ENABLE_ATTENDANCE_ANALYTICS,
} from "Constants/permissionConstants";

export const NAME_SORT_OPTIONS = [
  {
    key: "NAME_AZ",
    label: "common:full_name_az",
    sortEntity: "NAME",
    filterKey: "FULL_NAME",
    direction: "ASC",
  },
  {
    key: "NAME_ZA",
    label: "common:full_name_za",
    sortEntity: "NAME",
    filterKey: "FULL_NAME",
    direction: "DESC",
  },
  {
    key: "FIRSTNAME_AZ",
    label: "common:first_name_az",
    sortEntity: "FIRST_NAME",
    filterKey: "FIRST_NAME",
    direction: "ASC",
  },
  {
    key: "FIRSTNAME_ZA",
    label: "common:first_name_za",
    sortEntity: "FIRST_NAME",
    filterKey: "FIRST_NAME",
    direction: "DESC",
  },
  {
    key: "LASTNAME_AZ",
    label: "common:last_name_az",
    sortEntity: "LAST_NAME",
    filterKey: "LAST_NAME",
    direction: "ASC",
  },
  {
    key: "LASTNAME_ZA",
    label: "common:last_name_za",
    sortEntity: "LAST_NAME",
    filterKey: "LAST_NAME",
    direction: "DESC",
  },
];

export const SUBJECT_SORT_OPTIONS = [
  {
    key: "SUBJECTS_AZ",
    label: "toddleAnalytics:subject_az",
    sortEntity: "SUBJECT",
    direction: "ASC",
  },
  {
    key: "SUBJECTS_ZA",
    label: "toddleAnalytics:subject_za",
    sortEntity: "SUBJECT",
    direction: "DESC",
  },
];

export const CLASS_SORT_OPTIONS = [
  {
    key: "CLASSES_AZ",
    label: "toddleAnalytics:class_az",
    sortEntity: "COURSE",
    direction: "ASC",
  },
  {
    key: "CLASSES_ZA",
    label: "toddleAnalytics:class_za",
    sortEntity: "COURSE",
    direction: "DESC",
  },
];

export const LEARNING_COURSE_SORT_OPTIONS = [
  {
    key: "CLASSES_AZ",
    label: "common:course_name_az",
    sortEntity: "LEARNING_COURSE",
    direction: "ASC",
  },
  {
    key: "CLASSES_ZA",
    label: "common:course_name_za",
    sortEntity: "LEARNING_COURSE",
    direction: "DESC",
  },
];

export const ASSIGNMENT_SORT_OPTIONS = [
  {
    key: "ASSIGNMENTS_AZ",
    label: "toddleAnalytics:assignment_az",
    sortEntity: "ASSIGNMENT",
    direction: "ASC",
  },
  {
    key: "ASSIGNMENTS_ZA",
    label: "toddleAnalytics:assignment_za",
    sortEntity: "ASSIGNMENT",
    direction: "DESC",
  },
];

export const BEHAVIOUR_CATEGORY_SORT_OPTIONS = [
  {
    key: "CATEGORY_AZ",
    label: "toddleAnalytics:category_az",
    sortEntity: "BEHAVIOUR_CATEGORY",
    direction: "ASC",
  },
  {
    key: "CATEGORY_ZA",
    label: "toddleAnalytics:category_za",
    sortEntity: "BEHAVIOUR_CATEGORY",
    direction: "DESC",
  },
];

export const STAFF_PERFORMANCE_ANALYTICS_FILTER =
  "STAFF_PERFORMANCE_ANALYTICS_FILTER";
export const SUBJECT_PERFORMANCE_ANALYTICS_FILTER =
  "SUBJECT_PERFORMANCE_ANALYTICS_FILTER";
export const CLASS_PERFORMANCE_ANALYTICS_FILTER =
  "CLASS_PERFORMANCE_ANALYTICS_FILTER";
export const STUDENT_PERFORMANCE_ANALYTICS_FILTER =
  "STUDENT_PERFORMANCE_ANALYTICS_FILTER";
export const CLASS_DETAILED_PERFORMANCE_ANALYTICS_FILTER =
  "CLASS_DETAILED_PERFORMANCE_ANALYTICS_FILTER";
export const STAFF_DETAILED_PERFORMANCE_ANALYTICS_FILTER =
  "STAFF_DETAILED_PERFORMANCE_ANALYTICS_FILTER";

export const YEARGROUP_PERFORMANCE = "YEARGROUP_PERFORMANCE";
export const SUBJECT_PERFORMANCE = "SUBJECT_PERFORMANCE";
export const CLASS_PERFORMANCE = "CLASS_PERFORMANCE";
export const STAFF_PERFORMANCE = "STAFF_PERFORMANCE";
export const STUDENT_PERFORMANCE = "STUDENT_PERFORMANCE";
export const LEARNING_COURSE_PERFORMANCE = "LEARNING_COURSE_PERFORMANCE";
export const OVERVIEW_BEHAVIOUR = "OVERVIEW_BEHAVIOUR";
export const CATEGORY_BEHAVIOUR = "CATEGORY_BEHAVIOUR";
export const GRADE_BEHAVIOUR = "GRADE_BEHAVIOUR";
export const STUDENT_BEHAVIOUR = "STUDENT_BEHAVIOUR";
export const OVERVIEW_USAGE = "OVERVIEW_USAGE";
export const PLANNING_USAGE = "PLANNING_USAGE";
export const PORTFOLIO_USAGE = "PORTFOLIO_USAGE";
export const ASSIGNMENTS_USAGE = "ASSIGNMENTS_USAGE";
export const MESSAGING_USAGE = "MESSAGING_USAGE";
export const ANNOUNCEMENTS_USAGE = "ANNOUNCEMENTS_USAGE";

export const BEHAVIOUR_MODULES = {
  OVERVIEW_BEHAVIOUR,
  STUDENT_BEHAVIOUR,
};

export const LAST_7_DAYS = "LAST_7_DAYS";
export const LAST_30_DAYS = "LAST_30_DAYS";
export const LAST_90_DAYS = "LAST_90_DAYS";
export const LAST_6_MONTHS = "LAST_6_MONTHS";
export const CURRENT_ACADEMIC_YEAR = "CURRENT_ACADEMIC_YEAR";
export const PREVIOUS_ACADEMIC_YEAR = "PREVIOUS_ACADEMIC_YEAR";
export const DIVIDER = "DIVIDER";
export const GRADING_PERIOD = "GRADING_PERIOD";
export const CUSTOM_DURATION = "CUSTOM_DURATION";
export const PAST_ACADEMIC_YEARS = "PAST_ACADEMIC_YEARS";

export const ENGAGEMENT_ANALYTICS = "ENGAGEMENT";
export const PERFORMANCE_ANALYTICS = "PERFORMANCE";
export const BEHAVIOUR_ANALYTICS = "BEHAVIOUR";
export const MODULE_USAGE_ANALYTICS = "MODULE_USAGE";
export const ATTENDANCE_ANALYTICS = "ATTENDANCE";

export const DATE_VIEW_TYPE_ABBREVIATION = {
  [LAST_7_DAYS]: "toddleAnalytics:prev_7_days",
  [LAST_30_DAYS]: "toddleAnalytics:prev_30_days",
  [LAST_90_DAYS]: "toddleAnalytics:prev_90_days",
  [LAST_6_MONTHS]: "toddleAnalytics:prev_6_months",
  [CURRENT_ACADEMIC_YEAR]: "toddleAnalytics:prev_academic_year",
};

export const DATE_VIEW_TYPE_ABBREVIATION_V2 = {
  [LAST_7_DAYS]: "toddleAnalytics:last_7_days",
  [LAST_30_DAYS]: "toddleAnalytics:last_30_days",
  [LAST_90_DAYS]: "toddleAnalytics:last_90_days",
  [LAST_6_MONTHS]: "toddleAnalytics:last_6_months",
  [GRADING_PERIOD]: "toddleAnalytics:grading_period",
  [CURRENT_ACADEMIC_YEAR]: "toddleAnalytics:current_academic_year",
};

export const DATE_RANGE_OPTIONS = [
  {
    key: LAST_7_DAYS,
    value: LAST_7_DAYS,
    label: "common:last_7_days",
    modules: [
      ENGAGEMENT_ANALYTICS,
      BEHAVIOUR_ANALYTICS,
      MODULE_USAGE_ANALYTICS,
      ATTENDANCE_ANALYTICS,
    ],
  },
  {
    key: LAST_30_DAYS,
    value: LAST_30_DAYS,
    label: "common:last_30_days",
    modules: [
      ENGAGEMENT_ANALYTICS,
      BEHAVIOUR_ANALYTICS,
      MODULE_USAGE_ANALYTICS,
      ATTENDANCE_ANALYTICS,
    ],
  },
  {
    key: LAST_90_DAYS,
    value: LAST_90_DAYS,
    label: "common:last_90_days",
    modules: [ATTENDANCE_ANALYTICS],
  },
  {
    key: LAST_6_MONTHS,
    value: LAST_6_MONTHS,
    label: "common:last_6_months",
    modules: [MODULE_USAGE_ANALYTICS],
  },
  {
    key: GRADING_PERIOD,
    value: GRADING_PERIOD,
    label: "common:grading_period",
    modules: [BEHAVIOUR_ANALYTICS],
  },
  {
    key: CURRENT_ACADEMIC_YEAR,
    value: CURRENT_ACADEMIC_YEAR,
    label: "toddleAnalytics:current_academic_year",
    modules: [
      ENGAGEMENT_ANALYTICS,
      BEHAVIOUR_ANALYTICS,
      MODULE_USAGE_ANALYTICS,
      ATTENDANCE_ANALYTICS,
    ],
  },
  {
    key: PREVIOUS_ACADEMIC_YEAR,
    value: PREVIOUS_ACADEMIC_YEAR,
    label: "toddleAnalytics:previous_academic_year",
    modules: [
      ENGAGEMENT_ANALYTICS,
      MODULE_USAGE_ANALYTICS,
      ATTENDANCE_ANALYTICS,
    ],
  },
  {
    key: PAST_ACADEMIC_YEARS,
    value: PAST_ACADEMIC_YEARS,
    label: "toddleAnalytics:past_academic_years",
    modules: [BEHAVIOUR_ANALYTICS],
  },
  {
    key: CUSTOM_DURATION,
    value: CUSTOM_DURATION,
    label: "toddleAnalytics:custom_duration",
    modules: [
      ENGAGEMENT_ANALYTICS,
      BEHAVIOUR_ANALYTICS,
      MODULE_USAGE_ANALYTICS,
      ATTENDANCE_ANALYTICS,
    ],
  },
];

export const DATEVIEWTYPE_SUBVALUE_NAME_MAP = {
  [GRADING_PERIOD]: "dateViewGradingPeriod",
  [PAST_ACADEMIC_YEARS]: "academicYear",
};

export const REMOVABLE_DATE_VIEW_TYPES_WITH_SUBVALUE = [GRADING_PERIOD];

export const ALL_OPTION = {
  key: "all",
  value: "all",
  label: "All",
};

export const USER_TYPE_ENUM = {
  staff: "STAFF",
  student: "STUDENT",
  parent: "PARENT",
};

export const ANALYTICS_ENTITY_TYPE_ENUMS = {
  student: "STUDENT",
  staff: "STAFF",
  yearGroup: "YEAR_GROUP",
  subject: "SUBJECT",
  course: "COURSE",
  learningCourse: "LEARNING_COURSE",
  assignment: "ASSIGNMENT",
  grade: "GRADE",
  level: "LEVEL",
  incident: "INCIDENT",
  behaviourCategory: "BEHAVIOUR_CATEGORY",
  behaviourAction: "BEHAVIOUR_ACTION",
  behaviourLocation: "BEHAVIOUR_LOCATION",
  behaviourSeverity: "BEHAVIOUR_SEVERITY",
  behaviourSentiment: "BEHAVIOUR_SENTIMENT",
  OVERVIEW: "OVERVIEW",
  UNIT_PLAN: "UNIT_PLAN",
  ASSIGNMENT: "ASSIGNMENT",
  POST: "POST",
  MESSAGE: "MESSAGE",
  ANNOUNCEMENT: "ANNOUNCEMENT",
  CATEGORY_WISE_CODE: "CATEGORY_WISE_CODE",
  PERIOD: "PERIOD",
  ATTENDANCE_TIER: "ATTENDANCE_TIER",
  DATE: "DATE",
  COURSE_CREATED: "COURSES_CREATED",
  CLASSES_CREATED: "CLASSES_CREATED",
  UNIT_CREATED: "UNIT_CREATED",
  ASSIGNMENT_ASSIGNED: "ASSIGNMENT_ASSIGNED",
  POST_CREATED: "POST_CREATED",
  ANNOUNCEMENT_CREATED: "ANNOUNCEMENT_CREATED",
  PROGRESS_REPORT_CREATED: "PROGRESS_REPORT_CREATED",
  ATTENDANCE_CATEGORY: "ATTENDANCE_CATEGORY",
  GLOBAL_CATEGORY: "GLOBAL_CATEGORY",
  GRADE_SCALE: "GRADE_SCALE",
};

export const ANALYTICS_VIEW_TYPE_ENUMS = {
  overall: "OVERALL",
  subject: "SUBJECT",
  assignment: "ASSIGNMENT",
  GRADE: "GRADE",
  LEARNING_COURSE: "LEARNING_COURSE",
  COURSE: "COURSE",
  STAFF: "STAFF",
  STUDENT: "STUDENT",
  PARENT: "PARENT",
  FAMILY: "FAMILY",
  OVERVIEW: "OVERVIEW",
  GLOBAL_CATEGORY: "GLOBAL_CATEGORY",
};

export const SENTIMENT_VIEW_TYPE_ENUMS = {
  positive: "POSITIVE",
  negative: "NEGATIVE",
  neutral: "NEUTRAL",
};

export const ANALYTICS_STAFF_ROLE = {
  admin: "ADMIN",
  teacher: "TEACHER",
};

export const PAGINATION_LOADING_STATE_ROWS_COUNT = 2;
export const NUM_ROWS_TO_BE_FETCHED = 16;

export const MODULE_CONFIGURATION_MAP = {
  [ENGAGEMENT_ANALYTICS]: ENABLE_ENGAGEMENT_ANALYTICS,
  [PERFORMANCE_ANALYTICS]: ENABLE_PERFORMANCE_ANALYTICS,
  [BEHAVIOUR_ANALYTICS]: ENABLE_BEHAVIOUR_ANALYTICS,
  [MODULE_USAGE_ANALYTICS]: ENABLE_MODULE_USAGE_ANALYTICS,
  [ATTENDANCE_ANALYTICS]: ENABLE_ATTENDANCE_ANALYTICS,
};

const ENGAGEMENT_TEST_ID = "engagement";
const PERFORMANCE_TEST_ID = "performance";
const BEHAVIOUR_TEST_ID = "behaviour";
const MODULE_USAGE_TEST_ID = "usage";
const ATTENDANCE_TEST_ID = "attendance";

export const MODULE_TEST_ID_MAP = {
  [ENGAGEMENT_ANALYTICS]: ENGAGEMENT_TEST_ID,
  [PERFORMANCE_ANALYTICS]: PERFORMANCE_TEST_ID,
  [MODULE_USAGE_ANALYTICS]: MODULE_USAGE_TEST_ID,
  [ATTENDANCE_ANALYTICS]: ATTENDANCE_TEST_ID,
  [BEHAVIOUR_ANALYTICS]: BEHAVIOUR_TEST_ID,
};

export const DEFAULT_SORT_OPTION = {
  orderBy: "FIRST_NAME",
  orderByDirection: "ASC",
};

export const TODDLE_ANALYTICS_PERMS = [
  ENABLE_ENGAGEMENT_ANALYTICS,
  ENABLE_PERFORMANCE_ANALYTICS,
  ENABLE_BEHAVIOUR_ANALYTICS,
  ENABLE_MODULE_USAGE_ANALYTICS,
  ENABLE_ATTENDANCE_ANALYTICS,
];

export const ROUTE_MODULE_MAPPING = {
  performance: PERFORMANCE_ANALYTICS,
  engagement: ENGAGEMENT_ANALYTICS,
  behaviour: BEHAVIOUR_ANALYTICS,
  "module-usage": MODULE_USAGE_ANALYTICS,
  attendance: ATTENDANCE_ANALYTICS,
};

export const HEADING_LABELS = {
  [PERFORMANCE_ANALYTICS]: {
    grade: "toddleAnalytics:performance_insights_by_grade",
    subject: "toddleAnalytics:performance_insights_by_subject",
    class: "toddleAnalytics:performance_insights_by_class",
    staff: "toddleAnalytics:performance_insights_by_staff",
    student: "toddleAnalytics:performance_insights_by_student",
    "learning-course": "toddleAnalytics:performance_insights_by_course",
  },
  [BEHAVIOUR_ANALYTICS]: {
    overview: "toddleAnalytics:behaviour_insights_with_nomenclature",
    category: "toddleAnalytics:behaviour_insights_by_category",
    grade: "toddleAnalytics:behaviour_insights_by_grade",
    student: "toddleAnalytics:behaviour_insights_by_student",
  },
  [MODULE_USAGE_ANALYTICS]: {
    overview: "toddleAnalytics:overview_usage_insights",
    planning: "toddleAnalytics:planning_usage_insights",
    portfolio: "toddleAnalytics:portfolio_usage_insights",
    assignments: "toddleAnalytics:assignments_usage_insights",
    messaging: "toddleAnalytics:messaging_insights",
    announcements: "toddleAnalytics:announcements_usage_insights",
  },
  [ATTENDANCE_ANALYTICS]: {
    overview: "toddleAnalytics:attendance_insights_overview",
    grade: "toddleAnalytics:attendance_insights_by_grade",
    class: "toddleAnalytics:attendance_insights_by_class",
    student: "toddleAnalytics:attendance_insights_by_student",
  },
};

export const ROUTE_MAP = {
  "toddle-insights": {
    performance: {
      grade: {
        gradeId: {
          "student/studentId": {},
          "subject/subjectId": {
            "class/classId": {
              "student/studentId": {},
            },
            "student/studentId": {},
          },
          "learning-course/learningCourseId": {
            "student/studentId": {},
            "class/classId": {
              "student/studentId": {},
            },
          },
        },
      },
      subject: {
        subjectId: {
          "class/classId": {
            "student/studentId": {},
          },
          "student/studentId": {},
        },
      },
      class: {
        classId: {
          "student/studentId": {},
        },
      },
      staff: {
        staffId: {
          "class/classId": {
            "student/studentId": {},
          },
        },
      },
      student: {
        studentId: {},
      },
      "learning-course": {
        learningCourseId: {
          "class/classId": {
            "student/studentId": {},
          },
          "student/studentId": {},
        },
      },
    },
    behaviour: {
      overview: {
        "student/studentId": {},
      },
      category: {
        categoryId: {},
      },
      grade: {
        gradeId: {},
      },
      student: {
        studentId: {},
      },
    },
    attendance: {
      overview: {
        "student/studentId": {},
      },
      grade: {
        gradeId: {
          "student/studentId": {},
        },
      },
      class: {
        classId: {
          "student/studentId": {},
        },
      },
      student: {
        studentId: {},
      },
    },
  },
};

export const DEFAULT_VALUE_FOR_NO_DATA = 0;

export const SCORE_RANGES = [
  { min: 0, max: 20, label: "0-20%" },
  { min: 21, max: 40, label: "21-40%" },
  { min: 41, max: 60, label: "41-60%" },
  { min: 61, max: 80, label: "61-80%" },
  { min: 81, max: 100, label: "81-100%" },
];

export const EMPTY_STATE_TYPES = {
  NO_MATCHES_FOUND: "NO_MATCHES_FOUND",
  SOMETHING_WENT_WRONG: "SOMETHING_WENT_WRONG",
  GRADING_PERIODS_NOT_SETUP: "GRADING_PERIODS_NOT_SETUP",
};

export const EMPTY_STATE_HEADER_TEXT = {
  [EMPTY_STATE_TYPES.NO_MATCHES_FOUND]: "common:no_data_found",
  [EMPTY_STATE_TYPES.SOMETHING_WENT_WRONG]:
    "toddleAnalytics:oops_someting_went_wrong_on_our_side",
  [EMPTY_STATE_TYPES.GRADING_PERIODS_NOT_SETUP]:
    "toddleAnalytics:grading_periods_not_setup",
};

export const EMPTY_STATE_TEXT = {
  [EMPTY_STATE_TYPES.SOMETHING_WENT_WRONG]:
    "toddleAnalytics:please_try_and_refresh_the_page_or_reach_out_to_support",
};

export const QUERY_PARAM_DELIMITER = ",";
export const MAX_IB_DP_TOTAL = 42;
export const MAX_IB_MYP_TOTAL = 56;
export const MAX_IB_DP_GRADE = 7;
export const MAX_SCORE = 100;
export const MAX_CRITERIA_GRADE = 8;

export const CHART_CONSTANTS = {
  MAX_IB_DP_TOTAL,
  MAX_IB_MYP_TOTAL,
  MAX_IB_DP_GRADE,
  MAX_SCORE,
  SCORE_TICK_COUNT: 6,
  IB_GRADE_TICK_COUNT: 8,
  CRITERIA_GRADE_TICK_COUNT: 9,
  MAX_CRITERIA_GRADE,
};

export const VIEW_BY_OPTION_ENUM_MAP = {
  ib_dp_grade: "IB_DP_GRADE",
  ib_myp_grade: "IB_MYP_GRADE",
  average_ib_dp_grade: "AVERAGE_IB_DP_GRADE",
  average_ib_myp_grade: "AVERAGE_IB_MYP_GRADE",
  average_score: "AVERAGE_SCORE",
  ib_myp_total: "IB_MYP_TOTAL",
  score: "SCORE",
  ib_dp_total: "IB_DP_TOTAL",
  average_ib_dp_total: "AVERAGE_IB_DP_TOTAL",
  average_ib_myp_total: "AVERAGE_IB_MYP_TOTAL",
  grade_scale: "GRADE_SCALE",
};

export const OVERALL_SCORE_DISTRIBUTION_RANGE = [
  { min: 0, max: 20, label: "0-20%" },
  { min: 21, max: 40, label: "21-40%" },
  { min: 41, max: 55, label: "41-55%" },
  { min: 56, max: 70, label: "56-70%" },
  { min: 71, max: 80, label: "71-80%" },
  { min: 81, max: 90, label: "81-90%" },
  { min: 91, max: 96, label: "91-95%" },
  { min: 96, max: 100, label: "96-100%" },
];

export const IBDP_TOTAL_DISTRIBUTION_RANGE = [
  { min: 0, max: 10, label: "0-10" },
  { min: 11, max: 19, label: "11-19" },
  { min: 20, max: 23, label: "20-23" },
  { min: 24, max: 29, label: "24-29" },
  { min: 30, max: 34, label: "30-34" },
  { min: 35, max: 39, label: "35-39" },
  { min: 40, max: 42, label: "40-42" },
];

export const IBMYP_TOTAL_DISTRIBUTION_RANGE = [
  { min: 0, max: 10, label: "0-10" },
  { min: 11, max: 19, label: "11-19" },
  { min: 20, max: 27, label: "20-27" },
  { min: 28, max: 35, label: "28-35" },
  { min: 36, max: 40, label: "36-40" },
  { min: 41, max: 45, label: "41-45" },
  { min: 46, max: 50, label: "46-50" },
  { min: 51, max: 56, label: "51-56" },
];

export const LEVEL_LOCALES = {
  SL: "common:SL",
  HL: "common:HL",
};

export const DAILY = "DAILY";
export const MONTHLY = "MONTHLY";

export const CRITERIA_TYPE_TO_LABEL_MAP = {
  CRITERIA_A: "toddleAnalytics:criteria_a",
  CRITERIA_B: "toddleAnalytics:criteria_b",
  CRITERIA_C: "toddleAnalytics:criteria_c",
  CRITERIA_D: "toddleAnalytics:criteria_d",
};

export const NA = "N/A";

export const BAR_COLORS = [
  "var(--purple-700)",
  "var(--violet-800)",
  "var(--pink-700)",
  "var(--yellow-700)",
  "var(--green-700)",
  "var(--orange-700)",
  "var(--teal-700)",
  "var(--blue-700)",
  "var(--red-700)",
  "var(--purple-400)",
  "var(--violet-500)",
  "var(--pink-500)",
  "var(--yellow-500)",
  "var(--green-500)",
  "var(--orange-500)",
  "var(--teal-500)",
  "var(--blue-500)",
  "var(--red-400)",
  "var(--yellow-200)",
  "var(--blue-300)",
];

export const ENGAGEMENT_ACADEMIC_YEAR_SWITCHER_PERM =
  "FeatureFlag:EngagementAcademicYearSwitcher";
export const PERFORMANCE_ACADEMIC_YEAR_SWITCHER_PERM =
  "FeatureFlag:PerformanceAcademicYearSwitcher";
export const BEHAVIOUR_ACADEMIC_YEAR_SWITCHER_PERM =
  "FeatureFlag:BehaviourAcademicYearSwitcher";
export const MODULE_USAGE_ACADEMIC_YEAR_SWITCHER_PERM =
  "FeatureFlag:ModuleUsageAcademicYearSwitcher";
export const ATTENDANCE_ACADEMIC_YEAR_SWITCHER_PERM =
  "FeatureFlag:AttendanceAcademicYearSwitcher";

export const MODULE_ACADEMIC_YEAR_PERM_MAP = {
  [ENGAGEMENT_ANALYTICS]: ENGAGEMENT_ACADEMIC_YEAR_SWITCHER_PERM,
  [PERFORMANCE_ANALYTICS]: PERFORMANCE_ACADEMIC_YEAR_SWITCHER_PERM,
  [BEHAVIOUR_ANALYTICS]: BEHAVIOUR_ACADEMIC_YEAR_SWITCHER_PERM,
  [MODULE_USAGE_ANALYTICS]: MODULE_USAGE_ACADEMIC_YEAR_SWITCHER_PERM,
  [ATTENDANCE_ANALYTICS]: ATTENDANCE_ACADEMIC_YEAR_SWITCHER_PERM,
};

export const MODULE_USAGE_CUSTOM_DATE_RANGE_SELECTION_PERM =
  "FeatureFlag:AllowCustomDateRangeSelectionInModuleUsage";

export const ENGAGEMENT_CUSTOM_DATE_RANGE_SELECTION_PERM =
  "FeatureFlag:AllowCustomDateRangeSelectionInEngagement";

export const MODULE_CUSTOM_DATE_RANGE_SELECTION_PERM_MAP = {
  [MODULE_USAGE_ANALYTICS]: MODULE_USAGE_CUSTOM_DATE_RANGE_SELECTION_PERM,
  [ENGAGEMENT_ANALYTICS]: ENGAGEMENT_CUSTOM_DATE_RANGE_SELECTION_PERM,
};

export const BEHAVIOUR_NOMENCLATURE_CONSTANTS = {
  ACTION: "ACTION",
  LEVEL: "LEVEL",
  INCIDENT: "INCIDENT",
  MODULE: "MODULE",
};

export const BEHAVIOUR_NOMENCLATURE_LOCALE_PARAM_MAP = {
  [BEHAVIOUR_NOMENCLATURE_CONSTANTS.ACTION]: "action",
  [BEHAVIOUR_NOMENCLATURE_CONSTANTS.LEVEL]: "level",
  [BEHAVIOUR_NOMENCLATURE_CONSTANTS.INCIDENT]: "incident",
  [BEHAVIOUR_NOMENCLATURE_CONSTANTS.MODULE]: "module",
};

export const SEVERITIES_COLOR_MAP = {
  "#B0B0B0": "neutral",
  "#47CEAC": "teal",
  "#26C7D9": "blue",
  "#8888F2": "violet",
  "#FFBB33": "yellow",
  "#FF8DA6": "pink",
  "#FF8D38": "orange",
  "#A9D844": "green",
  "#C88AE8": "purple",
};

export const INCIDENT_STATUS = {
  RESOLVED: "RESOLVED",
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
};

export const FILTER_CURRICULUM_PROGRAM = "CURRICULUM_PROGRAM";
export const FILTER_ORGANIZATION = "ORGANIZATION";

export const PERFORMANCE_MULTI_TERMS_PERM = "FeatureFlag:PerformanceMultiTerms";

export const PERFORMANCE_ANALYTICS_COLOR_PANEL = [
  "var(--violet-600)",
  "var(--yellow-600)",
  "var(--green-600)",
  "var(--orange-600)",
  "var(--blue-600)",
  "var(--purple-600)",
  "var(--teal-600)",
];

export const LINE_COLOR_TO_DOT_COLOR_MAP = {
  "var(--violet-600)": "var(--violet-500)",
  "var(--yellow-600)": "var(--yellow-500)",
  "var(--green-600)": "var(--green-500)",
  "var(--orange-600)": "var(--orange-500)",
  "var(--blue-600)": "var(--blue-500)",
  "var(--purple-600)": "var(--purple-500)",
  "var(--teal-600)": "var(--teal-500)",
};

export const CONFIGURATION_GROUP_ANALYTICS = "Analytics";
export const ENABLE_PERFORMANCE_THRESHOLDS =
  "FeatureFlag:PerformanceThresholds";

export const IB_GRADE_THRESHOLD_CONFIG = "Analytics:IBGradeThreshold";
export const IBDP_TOTAL_THRESHOLD_CONFIG = "Analytics:IBDPTotalThreshold";
export const IBMYP_TOTAL_THRESHOLD_CONFIG = "Analytics:IBMYPTotalThreshold";
export const SCORE_THRESHOLD_CONFIG = "Analytics:OverallScoreThreshold";
export const CRITERIA_GRADE_THRESHOLD_CONFIG =
  "Analytics:CriterionAchievementLevelThreshold";

export const ATTENDANCE_ENTITY_TYPE = {
  OVERVIEW: "OVERVIEW",
  GRADE: "GRADE",
  COURSE: "COURSE",
  STUDENT: "STUDENT",
  PERIOD: "PERIOD",
};

export const ATTENDANCE_RECORDING_TYPE = {
  ONCE_A_DAY: "ONCE_A_DAY",
  EACH_PERIOD: "EACH_PERIOD",
  EACH_PERIOD_WITH_ONCE_A_DAY: "EACH_PERIOD_WITH_ONCE_A_DAY",
};

export const STAFF_ROLES = {
  ADMIN: "ADMIN",
  TEACHER: "TEACHER",
  HOMEROOM: "HOMEROOM",
};

export const SWITCHER_INFO_TYPE = {
  PROGRAMME: "PROGRAMME",
  TOTAL_STUDENTS: "TOTAL_STUDENTS",
  TOTAL_CLASSES: "TOTAL_CLASSES",
  GRADE: "GRADE",
  TEACHERS: "TEACHERS",
  PERIODS: "PERIODS",
  HOMEROOM_ADVISOR: "HOMEROOM_ADVISOR",
  FAMILY_MEMBERS: "FAMILY_MEMBERS",
  SCHOOL: "SCHOOL",
};

export const SWITCHER_INFO_TYPE_LABEL = {
  [SWITCHER_INFO_TYPE.PROGRAMME]: "common:programme",
  [SWITCHER_INFO_TYPE.TOTAL_STUDENTS]: "toddleAnalytics:total_students",
  [SWITCHER_INFO_TYPE.TOTAL_CLASSES]: "toddleAnalytics:total_classes",
  [SWITCHER_INFO_TYPE.GRADE]: "toddleAnalytics:grade",
  [SWITCHER_INFO_TYPE.TEACHERS]: "toddleAnalytics:teachers",
  [SWITCHER_INFO_TYPE.PERIODS]: "common:period_plural",
  [SWITCHER_INFO_TYPE.HOMEROOM_ADVISOR]: "toddleAnalytics:homeroom_advisor",
  [SWITCHER_INFO_TYPE.FAMILY_MEMBERS]: "toddleAnalytics:family_members",
  [SWITCHER_INFO_TYPE.SCHOOL]: "common:school",
};

export const MODULE_PERMS = {
  attendance: "FeatureFlag:AttendanceSettingsV2",
};

export const ENABLE_AI_ANALYTICS = "FeatureFlag:AIAnalytics";

export const AI_CHAT_HISTORY = "ai-chat-history";

export const REFERRER_CHAT_HISTORY = "chat_history";

export const ENABLE_EXTERNAL_DATA_SOURCE =
  "FeatureFlag:AIInsightExternalSources";

export const ENABLE_AI_INSIGHTS_IMAGE_SUPPORT =
  "FeatureFlag:AIInsightsImageSupport";

export const ALL_MODULES = "ALL_MODULES";

export const ENABLE_TOOL_CALL_MISS_CHECK =
  "FeatureFlag:ShowToolCallMissErrorMessage";

export const ENABLE_MARKING_RATE_VISIBILITY =
  "Permission:EnableMarkingRateVisibility";

export const ENABLE_ACCOUNT_CONFIGURATION_TERMINOLOGY =
  "FeatureFlag:EnableAccountConfiguration";
